define("command-palette/initializers/register-private-services", ["exports", "command-palette/services/command-palette/private/command-registry"], function (_exports, _commandRegistry) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.initialize = initialize;
  0; //eaimeta@70e063a35619d71f0,"command-palette/services/command-palette/private/command-registry"eaimeta@70e063a35619d71f
  function initialize(application) {
    const services = [{
      lookup: 'service:command-palette/private/command-registry',
      klass: _commandRegistry.default
    }];
    for (const service of services) {
      application.register(service.lookup, service.klass);
    }
  }
  var _default = _exports.default = {
    initialize
  };
});